<ng-template [appRouteDialog]="{ size: 'lg', config: { disableClose: true } }">
  <sb-dialog-header>
    <div>
      <h2 class="text-2xl font-bold text-default">{{ 'Ready to invite your team?' | translate }}</h2>
      <p class="text-lg text-support">
        {{ 'Great progress! Invite your team now, or feel free to finish up your schedule first.' | translate }}
      </p>
    </div>
  </sb-dialog-header>
  <sb-dialog-content>
    <employees-table [selectable]="true" [form]="form" />
  </sb-dialog-content>
  <sb-dialog-footer>
    <sb-dialog-footer-actions [align]="'end'">
      <button sb-button [disabled]="isLoading" (click)="skip()">
        {{ "I'll invite them later" | translate }}
      </button>
      <button
        sb-button
        [color]="'primary'"
        [sbLadda]="isLoading"
        (click)="submit()"
        [disabled]="selectedRowsCount === 0"
      >
        {{ 'Invite now' | translate }}
      </button>
    </sb-dialog-footer-actions>
  </sb-dialog-footer>
</ng-template>
